import React, { useEffect, useState } from "react";

import VesselDetails from "../../../components/VesselDetails/VesselDetails";
import axiosHttp from "../../../services/interceptor";
import { emitToasterMsg } from "../../../services/toasterUtility";
import Loader from "../../../common/Loader/Loader";

const baseUrl = process.env.REACT_APP_BASE_URL;

const ReportVesselDetailsPage = ({ reportDetails }) => {
	const [vesselData, setVesselData] = useState();
	const [loader, setLoader] = useState(false);

	const getVesselDetailsByVesselMstId = async (vesselMstId) => {
		setLoader(true);
		try {
			const response = await axiosHttp.get(
				`api/MyFleet/GetVesselById?vesselMstId=${vesselMstId}`
			);
			if (response?.data) {
				setLoader(false);
				setVesselData(response?.data?.Data);
			}
		} catch (error) {
			setLoader(false);
			emitToasterMsg("error", "Error", error?.message);
		}
	};

	useEffect(() => {
		if (reportDetails?.VesselMstId) {
			getVesselDetailsByVesselMstId(reportDetails?.VesselMstId);
		}
	}, [reportDetails?.VesselMstId]);

	return (
		<>
			{loader && <Loader />}{" "}
			{vesselData && (
				<VesselDetails
					vesselData={vesselData}
					vesselMstId={reportDetails?.VesselMstId}
					disabled={reportDetails?.IsParentReport}
					isParentReport={reportDetails?.IsParentReport}
					regulations={reportDetails?.Regulations}
					disableRiskAssessment = {true}
					isReportTab={true}
					reportStatus={reportDetails?.ReportStatus}
				/>
			)}
		</>
	);
};

export default ReportVesselDetailsPage;
